import styled from '@emotion/styled';
import { Preview } from './Preview';
import { SideBar } from './SideBar';

const Container = styled.div`
    display: flex;
    flex-grow: 1;
`;

export const VideoPage = ({ isCreatingAgent }: { isCreatingAgent: boolean }) => {
    return (
        <Container>
            <SideBar />
            <Preview isCreatingAgent={isCreatingAgent} />
        </Container>
    );
};
